import { useConfig } from "../lib/config";
import "./partnerstrip.css";

/**
 * Who else the operator works with, from the service's own list.
 *
 * **The list is the host's and the filter is this app's.** `lib/config.ts`
 * refuses anything that is not an https address on a live host, so a strip
 * rendered here cannot carry a dev or a qa link even if the environment holds
 * one. Nothing is filtered a second time in this file: one rule, in one place,
 * with the test on it.
 *
 * **No claim is made about any of them.** A name and a link. Nothing here says
 * a partner improves anything, because this product says that about nothing.
 *
 * Renders nothing at all when the host named no partners.
 *
 * Agent V5-C, wave 2.
 */
export function PartnerStrip() {
  const cfg = useConfig();
  const partners = cfg?.partner ?? [];
  if (partners.length === 0) return null;

  return (
    <section className="page partners" aria-labelledby="partners-head">
      <h2 id="partners-head" className="partners-head">We work with</h2>
      <ul className="partners-list">
        {partners.map((partner) => (
          <li key={partner.href}>
            <a
              className="partners-link"
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {partner.name}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
